import React, { FC } from "react";
import { formatNumber } from '@utils/helpers';
import { Row, Col } from "antd";
import "./tableCard.scss";

type TCardProps = {
    emp: any,
    handleClick: any
}
const TCard: FC<TCardProps> = ({ emp, handleClick }: TCardProps) => {
  return (
    <Col xs={{ span: 12 }} sm={{ span: 12 }} md={{ span: 8 }} lg={{ span: 6 }} xxl={{span: 4}}>
      <div className="tableCard">
        <div className="topSection">
          <div className="topLeft">
            <p className="f16 w500 name" onClick={handleClick}>{emp.patientName}</p>
            <p className="f14 w400 nameCode">{emp.patientId}</p>
          </div>
          <div className="topRight">
            {emp.patientStatus === "New" ? (
              <span className="f14 w500 clr-e100">{emp.patientStatus}</span>
            ) : emp.patientStatus === "Active" ? (
              <span className="f14 w500 clr-themeColor">{emp.patientStatus}</span>
            ) : emp.patientStatus === "Follow Up" ? (
              <span className="f14 w500 clr-darkBlue">{emp.patientStatus}</span>
            ) : (
              <span className="f14 w500 clr-s100">{emp.patientStatus}</span>
            )}
          </div>
        </div>
        <div className="content">
          <div className="section firstRow">
            <div className="sectionLeft">
              <p className="f14 w400 program">Program</p>
              <p className="f16 w500 programValue">{emp.program}</p>
            </div>
            <div className="sectionRight">
              <p className="f14 w400 program">Admission Risk</p>
              {emp.admissionsRiskFlag === "R" ? (
                <span className="f16 w400 hccVal clr-e100">{emp.admissionsRiskScore}</span>
              ) : emp.admissionsRiskFlag === "G" ? (
                <span className="f16 w400 hccVal clr-s100">{emp.admissionsRiskScore}</span>
              ) : (
                <span className="f16 w400 hccVal clr-themeColor">{emp.admissionsRiskScore}</span>
              )}
            </div>
          </div>
          <div className="section">
            <div className="sectionLeft">
              <p className="f14 w400 program">Assigned PCP Name</p>
              <p className="f16 w500 programValue">{emp.PCPName}</p>
            </div>
            <div className="sectionRight">
              <p className="f14 w400 program">Last Year Cost</p>
              <p className="f16 w500 programValue">
                $ {" " + formatNumber(parseFloat(emp.lastYearCost))}
              </p>
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

type TtableCardProps = {
  empData: any;
  handleClick: any;
};

const TableCard: FC<TtableCardProps> = ({ empData, handleClick }: TtableCardProps) => {
  return (
    <div className="cardWrap">
      <Row gutter={{lg: 16, md:16, sm: 8, xs: 8}}>
        {empData.map((emp: any): any => {
          return <TCard emp={emp} key={emp.patientId} handleClick={()=>handleClick(emp)}/>;
        })}
      </Row>
    </div>
  );
};

export default TableCard;